'use client';
import React from 'react';
import { Box, List, ListItem, Stack } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import WildsLaunchContainer from '../WildsLaunchContainer';
import Image from 'next/image';
import cn from './style.module.scss';
interface WildsLaunchLocationProps {
  tabThemeImageBackground: any;
  locationThemeImage: any;
  LocationBackgroundImage: any;
  experienceElements: string[];
  t: any;
  layoutClass?: string;
}
export default function WildsLaunchLocation(props: WildsLaunchLocationProps) {
  const { layoutClass = '', t, experienceElements } = props;

  return (
    <Box component="section" className={cn.wildsLaunchLocation}>
      <Box
        className={cn.wildsLocationBackground}
        sx={{
          backgroundImage: `url(${props.LocationBackgroundImage.url})`,
        }}
      >
        {' '}
        <Image
          src={props.LocationBackgroundImage.url}
          alt="Wilds Launch Location - Location Background Image"
          width={768}
          height={768}
        />
      </Box>
      <Stack
        component="section"
        className={`${cn.wildsDataWrapper} ${cn[layoutClass]}`}
      >
        <WildsLaunchContainer>
          <Box component="div" className={cn.wildsDataBlock}>
            <Box component="article" className={cn.wildsSpecContent}>
              <Box component="div" className={cn.wildsDataHeading}>
                <h2>{ReactHtmlParser(t['locationHeading'])}</h2>
                <p>{ReactHtmlParser(t['locationTextContent'])}</p>
              </Box>
              <Box component="div" className={cn.wildsDataElement}>
                <List className={cn.wildsDataList}>
                  {experienceElements?.map((item, index) => (
                    <ListItem key={index}>{item}</ListItem>
                  ))}
                </List>
              </Box>
            </Box>
            <Box component="picture" className={cn.wildsDataTheme}>
              <Box component="div" className={cn.wildsThemeImage}>
                <Image
                  src={props.locationThemeImage.url}
                  alt={'Location Image'}
                  width={500}
                  height={400}
                />
              </Box>
              <Box
                component="div"
                className={cn.wildsThemeGraphics}
                sx={{
                  backgroundImage: `url(${props.tabThemeImageBackground.url})`,
                }}
              />
            </Box>
          </Box>
        </WildsLaunchContainer>
      </Stack>
    </Box>
  );
}
